'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "SkeletonBodyTextContainer": "Polaris-SkeletonBodyText__SkeletonBodyTextContainer",
  "SkeletonBodyText": "Polaris-SkeletonBodyText"
};

exports.default = styles;
